var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('student-info'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 px-1"},[_c('current-schedule'),_vm._v(" "),_c('current-holds')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }